import { useCallback, useEffect, useMemo, useState } from 'react'
import { scoreboardConstants } from '../../../../constants/scoreboardConstants'
import { useSwiper } from '../../../../hooks/useSwiper'

export const useScoreboardSwiper = () => {
	const [activeSlide, setActiveSlide] = useState(0)
	const [swiper, setSwiper] = useState<any>(null)

	const swiperOptions = useMemo(
		() => ({
			slidesPerView: scoreboardConstants.swiper.slidesPerView,
			spaceBetween: scoreboardConstants.swiper.spaceBetween,
			centeredSlides: true,
			allowTouchMove: true,
			loop: false,
			speed: scoreboardConstants.swiper.speed,
			touchRatio: scoreboardConstants.swiper.touchRatio,
			touchAngle: scoreboardConstants.swiper.touchAngle,
			grabCursor: true,
			on: {
				slideChange: (swiper: any) => {
					setActiveSlide(swiper.activeIndex)
				},
				init: (swiper: any) => {
					setSwiper(swiper)
				},
			},
		}),
		[]
	)

	const swiperRef = useSwiper('.scoreboard-swiper', swiperOptions)

	useEffect(() => {
		if (swiperRef.current) {
			setSwiper(swiperRef.current)
		}
	}, [swiperRef.current])

	const handleDotClick = useCallback(
		(index: number) => {
			if (swiper) {
				swiper.slideTo(index)
			}
		},
		[swiper]
	)

	return {
		activeSlide,
		handleDotClick,
	}
}
